import { render } from "./Subheader.vue?vue&type=template&id=3c2ef280"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
script.render = render

export default script